import { render, staticRenderFns } from "./brokerForm.vue?vue&type=template&id=f531b9a0&scoped=true&"
import script from "./brokerForm.vue?vue&type=script&lang=js&"
export * from "./brokerForm.vue?vue&type=script&lang=js&"
import style0 from "./brokerForm.vue?vue&type=style&index=0&id=f531b9a0&scoped=true&lang=css&"
import style1 from "./brokerForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f531b9a0",
  null
  
)

export default component.exports